import React from "react";
import { FormProvider, useForm } from "react-hook-form";
import ProviderInformation from "./forms/ProviderInformation";
import PracticeInformation from "./forms/PracticeInformation";
import PracticeLocationInformation from "./forms/PracticeLocationInformation";
import UserDetails from "./forms/UserDetails";
import {
  Modal,
  Step as MStep,
  StepLabel,
  Stepper,
  IconButton,
} from "@mui/material";
import CloseIcon from "@material-ui/icons/Close";

import { addPractice, validatePracticeDetails } from "apiHandler/actions";
import { useUserData } from "components/customHooks/userDataContext";

const formArray = [
  {
    id: 0,
    name: "Practice",
    heading: "Add Practice",
    component: <PracticeInformation />,
  },
  {
    id: 1,
    name: "Provider",
    heading: "Add Provider Details",
    component: <ProviderInformation />,
  },
  {
    id: 2,
    name: "Location",
    heading: "Add Practice Location",
    component: <PracticeLocationInformation />,
  },

  {
    id: 3,
    name: "UserDetails",
    heading: "Add User Details",
    component: <UserDetails />,
  },
];

const BasicStepperForm = ({ onClose, setSnackbarMessage }) => {
  const [currentForm, setCurrentForm] = React.useState(0);
  const [errorMessage, setErrorMessage] = React.useState("");
  const userData = useUserData();

  const handleBack = (e) => {
    e.preventDefault();
    if (currentForm > 0) {
      setCurrentForm(currentForm - 1);
    }
  };

  const providerDetailValues = ["address1", "city", "state_cd", "zip"];

  const locationDetailValues = [
    "address_line1",
    "city",
    "state_cd",
    "zip_code",
  ];

  const practiceDetailsValues = ["practice_name"];

  const userDetailValues = ["user_id", "password", "phone", "user_role"];

  const methods = useForm({
    defaultValues: {
      practice: {
        practice_name: "",
        status: "",
        npi_primary: "",
        source_entity: "Orci Care",
        subscription_type: ["Provider"],
      },
      provider: [
        {
          provider_type: "",
          npi: "",
          first_name: "",
          last_name: "",
          address1: "",
          address2: "",
          display_name: "",
          status_cd: "",
          offline_consultation: "",
          provider_image: "",
          city: "",
          state_cd: "",
          zip: "",
          phone: "",
          tax_id: "",
          tax_id_type: "",
        },
      ],
      practice_location: [
        {
          address_line1: "",
          address_line2: "",
          city: "",
          phone: "",
          email: "",
          zip_code: "",
          state_cd: "",
          time_zone: "EST",
          primary_loc_flag: "",
          service_loc_code: "",
          service_loc_description: "",
          service_loc_npi: "",
        },
      ],
      user: [
        {
          user_name: "",
          user_role: "",
          user_id: "",
          status: "",
          full_name: "",
          first_name: "",
          last_name: "",
          title: "",
          npi: "",
          password: "",
          phone: "",
        },
      ],
    },
    mode: "onChange",
  });

  const validateForm = (obj) => {
    if (currentForm === 0) {
      let flag = true;
      for (let i = 0; i < practiceDetailsValues.length; i++) {
        let val = obj.practice[practiceDetailsValues[i]];
        if (!val || val.length < 1) {
          flag = false;
        }
      }

      if (!flag) return false;
    } else if (currentForm === 1) {
      let flag = true;
      obj.provider.map((p) => {
        for (let i = 0; i < providerDetailValues.length; i++) {
          let val = p[providerDetailValues[i]];
          if (!val || val.length < 1) {
            flag = false;
          }
        }
      });

      if (!flag) return false;
    } else if (currentForm === 2) {
      let flag = true;
      obj.practice_location.map((p) => {
        for (let i = 0; i < locationDetailValues.length; i++) {
          let val = p[locationDetailValues[i]];
          if (!val || val.length < 1) {
            flag = false;
          }
        }
      });

      if (!flag) return false;
    } else if (currentForm === 3) {
      let flag = true;
      obj.user.map((p) => {
        for (let i = 0; i < userDetailValues.length; i++) {
          let val = p[userDetailValues[i]];
          if (!val || val.length < 1) {
            flag = false;
          }
        }
      });
      if (!flag) return false;
    }
    return true;
  };

  const validateDetails = async () => {
    const { user, provider } = methods.getValues();
    let payload = {};
    // if(currentForm === 0) {
    //   payload = {
    //     "type": "orci_provider",
    //     "search_criteria": provider.map((pro, index) => ({ npi: pro.npi, display_name: pro.display_name, id: index }))
    //   }
    // }
    if (currentForm === 1) {
      payload = {
        type: "orci_provider",
        search_criteria: provider.map((pro, index) => ({
          npi: pro.npi,
          display_name: pro.display_name,
          id: index,
        })),
      };
    } else if (currentForm === 3) {
      payload = {
        type: "user",
        search_criteria: user.map((pro, index) => ({
          user_id: pro.user_id,
          id: index,
        })),
      };
    }
    const response = await validatePracticeDetails(
      payload,
      userData.access_token
    );

    if (response?.code === 500) {
      response.message.map((x) =>
        methods.setError(
          currentForm === 1 ? `provider[${x.id}].npi` : `user[${x.id}].user_id`,
          {
            type: "required",
            message: x.message,
          }
        )
      );
      return true;
    }
    return false;
  };
  const handleContinue = async (e) => {
    e.preventDefault();
    methods.trigger();
    const validated = validateForm(methods.getValues());
    if (validated) {
      const response =
        [1, 3].includes(currentForm) && (await validateDetails());

      if (!response && currentForm < formArray.length - 1) {
        setCurrentForm(currentForm + 1);
      }
    }
  };

  const handleConfirm = async (e) => {
    e.preventDefault();
    methods.trigger();
    const validated = validateForm(methods.getValues());

    if (validated) {
      const response =
        [1, 3].includes(currentForm) && (await validateDetails());

      if (!response) {
        const data = methods.getValues();
        const payload = {
          ...data,
          practice: {
            ...data.practice,
            source_entity: "Orci Care",
            logged_in_mail: userData.email,
            logged_in_user_name: `${userData?.first_name} ${userData?.last_name}`,
          },
          practice_location: {
            ...data.practice_location[0],
            primary_loc_flag: "Yes",
          },

          user: data.user.map((data) => ({
            ...data,
            phone: /^((\+91)|\+)[7-9][0-9]{9}$/.test(data.phone)
              ? data.phone
              : `+91${data.phone}`,
          })),
        };
        const response = await addPractice(payload, userData.access_token);
        if (response.success) {
          onClose();
          setSnackbarMessage(response.success);
        } else {
          setErrorMessage("Failed to save practice, Please try again!");
        }
      }
    }
  };

  return (
    <Modal open={true} onClose={onClose}>
      <div className="upload-multiLevel-practice-modal">
        <IconButton style={{ float: "right" }} onClick={onClose}>
          <CloseIcon />
        </IconButton>
        <div>
          <Stepper activeStep={currentForm} style={{ marginTop: 10 }}>
            {formArray.map((step, index) => (
              <MStep key={index}>
                <StepLabel>{step.name}</StepLabel>
              </MStep>
            ))}
          </Stepper>
          <div>
            <h1 className="udm-title">{formArray[currentForm].heading}</h1>
            <div className="form-component">
              <FormProvider {...methods}>
                <form method="POST">
                  {formArray[currentForm].component}
                  <div className="udm-btn-cont">
                    {currentForm > 0 && (
                      <button className="blank-hover-btn" onClick={handleBack}>
                        Back
                      </button>
                    )}

                    {currentForm === formArray.length - 1 ? (
                      <button
                        className="udm-save"
                        onClick={handleConfirm}
                        type="submit"
                      >
                        Confirm
                      </button>
                    ) : (
                      <button className="udm-save" onClick={handleContinue}>
                        Continue
                      </button>
                    )}
                  </div>
                  <div>
                    <p style={{ color: "red" }}>{errorMessage}</p>
                  </div>
                </form>
              </FormProvider>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default BasicStepperForm;
